import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
const LeaveApply = React.lazy(() =>
  import("@/pages/leave/leaveApply/LeaveApply")
);
const LeaveBalance = React.lazy(() =>
  import("@/pages/leave/leaveBalance/LeaveBalance")
);
const LeaveCalendar = React.lazy(() =>
  import("@/pages/leave/leaveCalendar/LeaveCalendar")
);
const LeaveApproval = React.lazy(() =>
  import("@/pages/leave/leaveApproval/LeaveApproval")
);
const LeaveEncashment = React.lazy(() =>
  import("@/pages/leave/encashment/LeaveEncashment")
);
const RestrictedHolidayApply = React.lazy(() =>
  import("@/pages/leave/restrictedHoliday/RestrictedHolidayApply")
);
const CompOff = React.lazy(() => import("@/pages/leave/compOff/CompOff"));
const WithdrawLeaveApply = React.lazy(() =>
  import("@/pages/leave/withdrawLeave/WithdrawLeaveApply")
);
const PaternityLeave = React.lazy(() =>
  import("@/pages/leave/paternityLeave/PaternityLeave")
);
const History = React.lazy(() =>
  import("@/pages/leave/leaveHistory/LeaveHistory")
);
const MaternityLeave = React.lazy(() =>
  import("@/pages/leave/maternityLeave/MaternityLeave")
);
const LeaveHistory = React.lazy(() =>
  import("@/pages/leave/leaveHistory/LeaveHistory")
);
const RmLeaveReport = React.lazy(() =>
  import("@/pages/leave/leaveReport/LeaveReport")
);
const TeamMemberLeaveBalance = React.lazy(() =>
  import("@/pages/leave/teamMemberLeaveBalance/TeamMemberLeaveBalance")
);

const Leave = [
  {
    path: "/leaveApply",
    element: (
      <SuspenseWrapper>
        <LeaveApply />
      </SuspenseWrapper>
    ),
  },
  {
    path: "LeaveBalance",
    element: (
      <SuspenseWrapper>
        <LeaveBalance />
      </SuspenseWrapper>
    ),
  },
  {
    path: "LeaveApproval",
    element: (
      <SuspenseWrapper>
        <LeaveApproval />
      </SuspenseWrapper>
    ),

  },
  {
    path: "LeaveHistory",
    element: (
      <SuspenseWrapper>
        <LeaveHistory />
      </SuspenseWrapper>
    ),
  },
  {
    path: "LeaveCalendar",
    element: (
      <SuspenseWrapper>
        <LeaveCalendar />
      </SuspenseWrapper>
    ),
  },
  {
    path: "LeaveEncashment",
    element: (
      <SuspenseWrapper>
        <LeaveEncashment />
      </SuspenseWrapper>
    ),
  },
  {
    path: "restrictedHolidayApply",
    element: (
      <SuspenseWrapper>
        <RestrictedHolidayApply />
      </SuspenseWrapper>
    ),
  },
  {
    path: "compOff",
    element: (
      <SuspenseWrapper>
        <CompOff />
      </SuspenseWrapper>
    ),
  },
  {
    path: "withdrawLeaveApply",
    element: (
      <SuspenseWrapper>
        <WithdrawLeaveApply />
      </SuspenseWrapper>
    ),
  },
  {
    path: "paternityLeave",
    element: (
      <SuspenseWrapper>
        <PaternityLeave />
      </SuspenseWrapper>
    ),
  },
  {
    path: "history",
    element: (
      <SuspenseWrapper>
        <History />
      </SuspenseWrapper>
    ),
  },
  {
    path: "maternityLeave",
    element: (
      <SuspenseWrapper>
        <MaternityLeave />
      </SuspenseWrapper>
    ),
  },
  {
    path: "rmLeaveReport",
    element: (
      <SuspenseWrapper>
        <RmLeaveReport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "teamMemberLeaveBalance",
    element: (
      <SuspenseWrapper>
        <TeamMemberLeaveBalance />
      </SuspenseWrapper>
    ),
  }
];

export default Leave;
